
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ErrorStateProps {
  error: string | null;
  isPublic?: boolean;
}

export const ErrorState = ({ error, isPublic }: ErrorStateProps) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-gray-900">Profile Not Found</h2>
        <p className="mt-2 text-gray-600">
          {error || "The requested profile does not exist."}
        </p>
        {!isPublic && (
          <Button
            onClick={() => navigate("/edit-profile")}
            className="mt-4"
          >
            Setup Profile
          </Button>
        )}
      </div>
    </div>
  );
};
